<app-dossier
  eyebrow="Dossier agent // Onboarding"
  [reference]="operation.value()?.codeName ?? null"
>
  @if (operation.isLoading() && !operation.hasValue()) {
    <app-state-panel kind="loading" title="Ouverture du dossier…" />
  } @else if (notFound()) {
    <app-state-panel
      kind="error"
      title="Dossier introuvable"
      message="Vérifiez le lien reçu de l'organisateur."
    />
  } @else if (loadError(); as message) {
    <app-state-panel kind="error" title="Transmission impossible" [message]="message">
      <button class="button button--secondary" type="button" (click)="operation.reload()">
        Réessayer
      </button>
    </app-state-panel>
  } @else if (!recruiting()) {
    <app-state-panel
      kind="empty"
      title="Recrutement clos"
      message="Cette opération n'accepte plus de nouveaux agents."
    >
      <a class="button button--secondary" [routerLink]="['/operations', operationId()]"
        >Suivre l'opération</a
      >
    </app-state-panel>
  } @else {
    <div class="viewfinder">
      <img src="/assets/silhouette.svg" alt="" />
    </div>

    <h1 class="greeting">
      Bonjour agent,<br />
      pour rejoindre cette partie<br />
      veuillez décliner<br />
      <span class="highlight">votre identité</span>
    </h1>

    <form class="form" (submit)="enroll($event)" novalidate>
      <div class="field">
        <label class="field__label" for="first-name">Prénom</label>
        <input
          #firstNameInput
          class="field__input"
          id="first-name"
          type="text"
          autocomplete="given-name"
          maxlength="100"
          placeholder="Bob"
          (input)="firstName.set(firstNameInput.value)"
        />
        <p class="field__hint">
          Visible des autres agents. Un surnom fait l'affaire : Bob le grand, pour ne pas le
          confondre avec Bob de 1 m 35.
        </p>
      </div>

      <div class="field field--short" [class.field--invalid]="error()?.field === 'codeName'">
        <label class="field__label" for="code-name">Nom de code</label>
        <input
          #codeNameInput
          class="field__input"
          id="code-name"
          type="text"
          autocomplete="off"
          maxlength="100"
          placeholder="Le décolleur"
          [attr.aria-invalid]="error()?.field === 'codeName' ? true : null"
          (input)="codeName.set(codeNameInput.value)"
        />
        @if (error()?.field === 'codeName') {
          <p class="field__error">{{ error()?.message }}</p>
        } @else {
          <p class="field__hint">Votre identité d'agent pendant toute la partie.</p>
        }
      </div>

      <div #turnstile class="turnstile"></div>

      @if (error(); as error) {
        @if (!error.field) {
          <p class="field__error" role="alert">{{ error.message }}</p>
        }
      }

      <p class="annotation annotation--end" aria-hidden="true">Rapport au QG ↙</p>

      <button class="button button--primary button--block" type="submit" [disabled]="!canSubmit()">
        {{ submitting() ? 'Transmission…' : 'Rejoindre la partie' }}
        <span class="button__arrow" aria-hidden="true">›</span>
      </button>
    </form>

    <section class="card id-card" aria-label="Aperçu de votre fiche d'agent">
      <img class="paperclip paperclip--small" src="/assets/paperclip.svg" alt="" />
      <img class="portrait portrait--small" src="/assets/silhouette.svg" alt="" />
      <dl class="facts">
        <dt>Agent</dt>
        <dd>{{ codeName().trim() || 'En formation' }}</dd>
        <dt>Statut</dt>
        <dd>Recrue</dd>
        <dt>Opération</dt>
        <dd>{{ operation.value()?.codeName }}</dd>
        <dt>Accès</dt>
        <dd>Niveau 1</dd>
      </dl>
      <p class="stamp stamp--round stamp--pinned" aria-hidden="true">Mission<br />sociale</p>
    </section>
  }
</app-dossier>
